import { render } from "./ComponentPatientShortcuts.vue?vue&type=template&id=1515da1e&scoped=true"
import script from "./ComponentPatientShortcuts.vue?vue&type=script&lang=js"
export * from "./ComponentPatientShortcuts.vue?vue&type=script&lang=js"

import "./ComponentPatientShortcuts.vue?vue&type=style&index=0&id=1515da1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1515da1e"]])

export default __exports__